import React from 'react';
import RIEBase from 'components/core/editable/RIEBase';

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 * Editable text area.
 * Component value is a string.
 */
export default class RIETextArea extends RIEBase {

    /**
     * We have to override the base class's implementation
     * of this method because we don't want to finish editing when
     * you click the Enter key.
     * @param event
     */
    keyDown = (event) => {
        if (event.keyCode === 27) { // Escape
            this.cancelEditing();
        }
    };

    renderEditingComponent = () => {
        return (
            <textarea
                rows={this.props.rows}
                cols={this.props.cols}
                disabled={this.state.loading}
                className={this.makeClassString()}
                defaultValue={this.props.value}
                onInput={this.textChanged}
                ref="input"
                {...this.props.editProps}
            />
        );
    };

    renderNormalComponent = () => {
        return (
            <textarea
                rows={this.props.rows}
                cols={this.props.cols}
                disabled={this.state.loading}
                className={this.makeClassString()}
                defaultValue={this.props.value}
                onInput={this.textChanged}
                ref="input"
                {...this.props.editProps}
                {...this.getStartEditingProps()}
            />
        );
    }

    renderReadComponent = () => {
        const value = this.getNewValue();
        const spansAndBrs = [];
        let i = 0;
        value.split('\n').forEach(line => {
            spansAndBrs.push(<span key={i}>{line}</span>);
            spansAndBrs.push(<br key={i + 1} />);
            i += 2;
        });
        spansAndBrs.pop(); // remove last br tag

        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (
            <span
                tabIndex="0"
                className={this.makeClassString()}
                {...this.getStartEditingProps()}
                {...this.props.defaultProps}
            >
                {spansAndBrs}
            </span>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIETextArea.js